import React, {useEffect,useState} from 'react';

export default function BrandIcon({website,className='w-10 h-10'}){
  const domain=(website.domain||'').replace(/^https?:\/\//,'').replace(/\/$/,'');
  const source=website.brandIcon||(/^[a-z\d.-]+\.[a-z]{2,}$/i.test(domain)?`https://${domain}/favicon.ico`:null);
  const [failed,setFailed]=useState(false);
  useEffect(()=>setFailed(false),[source]);
  const name=website.brandName||domain||'Brand';
  const initials=name.split(/[\s.-]+/).filter(Boolean).slice(0,2).map(s=>s[0]).join('').toUpperCase();
  return <span className={`${className} shrink-0 rounded-lg border bg-muted flex items-center justify-center overflow-hidden`}>
    {source&&!failed?<img src={source} alt={`${name} icon`} className="w-full h-full object-contain p-1" referrerPolicy="no-referrer" onError={()=>setFailed(true)}/>:<span className="text-sm font-semibold" aria-label={`${name} initials`}>{initials}</span>}
  </span>;
}
